module.exports = __webpack_public_path__ + "static/media/thetechcreators.b17845cd.jpg";